module.exports = __webpack_public_path__ + "img/section1_bg.0ed01df0.png";